export const createIsSecureContext = (window) => window !== null && window.isSecureContext;
//# sourceMappingURL=is-secure-context.js.map